export default "/img/lock.svg"